<template>
  <div class="p-[12px] border rounded">
    <!-- <b-card
      class="mb-2 !p-1 border rounded"
      header-tag="header"
      header-class="bg-white"
    > -->
    <b-form @submit.prevent="onSubmit">
      <b-row class="mb-[10px]">
        <b-col cols="12">
          <b-form-group
            id="input-group-1"
            label="Nama Gudang*"
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              v-model="warehouseName"
              type="text"
              placeholder="Tulis Nama Gudang Kamu"
              required
            />
          </b-form-group>
        </b-col>
      </b-row>
      <!-- <b-row class="mb-2">
        <b-col cols="12">
          <b-form-group
            id="input-group-2"
            label="Alamat Gudang*"
            label-for="input-2"
          >
            <b-form-input
              id="input-2"
              v-model="warehouseAddress"
              type="text"
              placeholder="Tulis Alamat Gudang"
              required
            />
          </b-form-group>
        </b-col>
      </b-row> -->
      <b-row class="mb-[10px]">
        <b-col cols="12">
          <b-form-group
            id="input-group-3"
            label="Kecamatan / Kelurahan*"
            label-for="input-3"
          >
            <vSelect
              id="input-3"
              v-model="warehouseCity"
              placeholder="Masukan kelurahan atau kecamatan"
              required
              :options="itemsOriginEdit"
              @search="onSearchOrigin"
            >
              <template #search="{ attributes, events }">
                <input
                  class="vs__search"
                  :required="!warehouseCity"
                  v-bind="attributes"
                  v-on="events"
                >
              </template>
            </vselect>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label-cols-md="4">
            <template
              #label
              class="mr-1"
            >
              <h5 class="text-black">
                Alamat Detail<span class="text-primary">*</span>
              </h5>
              <small>
                Alamat ini akan jadi petunjuk kurir saat mau
                jemput barang. Pastikan kamu isi dengan detail ya.
              </small>
            </template>

            <b-form-textarea
              v-model="warehouseAddress"
              placeholder="Contoh: Jl. Raya Tamansari, Kompleks Karangwuni, Desa, Dusun I, Tamansari, Karangmoncol, Kabupaten Purbalingga, Jawa Tengah 53355"
              rows="3"
              required
              minlength="50"
              maxlength="85"
              class="!w-full"
            />
            <!-- <b-row class="justify-content-between">
              <b-col>
                <div>
                  <small class="text-primary mt-50">{{
                    errors[0]
                  }}</small>
                </div>
              </b-col>
            </b-row> -->
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mb-[10px]">
        <b-col cols="12">
          <b-form-group label-cols-md="4">
            <template #label>
              <h5 class="text-black">
                Pasang Lokasi Peta<span class="text-primary">*</span>
              </h5>
            </template>
            <b-button
              v-b-modal.modalMap
              variant="outline-primary"
              class="btn-icon d-flex w-full"
              :disabled="!warehouseCity"
            >
              <span class="k-location h-100 font-bold text-10 align-middle mx-[5px]" />
              <span class="text-left">{{ addressNameMaps || 'Pilih titik lokasi' }}</span>
            </b-button>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row
        v-if="isKomshipUser"
        class="d-flex  mb-1"
      >
        <b-col md="6">
          <h4 class="text-black">
            <strong>Penanggung Jawab</strong>
          </h4>
        </b-col>
      </b-row>
      <b-row v-if="isKomshipUser">
        <b-col cols="12">
          <b-form-group label-cols-md="4">
            <template #label>
              <h5 class="text-black">
                Nama<span class="text-primary">*</span>
              </h5>
            </template>

            <b-form-input
              v-model="picName"
              :required="isKomshipUser"
              placeholder="Masukkan Nama Penanggung Jawab Gudang"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label-cols-md="4">
            <template #label>
              <h5 class="text-black">
                No. HP<span class="text-primary">*</span>
              </h5>
              <small>
                Kurir yang jemput akan menghubungi nomor ini
              </small>
            </template>
            <phone-input
              :check-wa="false"
              :required="isKomshipUser"
              @update:dataForParent="setCustomerPhone"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <div class="justify-end flex gap-1 mt-2">
        <b-button
          size="sm"
          variant="outline-primary"
          @click="onCancel"
        >
          Batal
        </b-button>
        <b-button
          size="sm"
          type="submit"
          :disabled="isLoading"
          variant="primary"
        >
          Simpan
        </b-button>

      </div>
    </b-form>
    <!-- </b-card> -->
    <ModalMap
      :initial-places="initialPlaces"
      :address-selected="warehouseCity"
      @selected="updateDataLocation"
    />
  </div>
</template>

<script>
import vSelect from 'vue-select'
import phoneInput from '@/views/components/input/phoneInput.vue'
import { apiAddWareHouses } from './service/api.warehouse.service'
import ModalMap from '../../warehouse/component/ModalMap.vue'

export default {
  name: 'AddWhereHouse',
  components: {
    vSelect,
    phoneInput,
    ModalMap,
  },
  data() {
    return {
      warehouseName: '',
      warehouseAddress: '',
      isLoading: false,
      picName: '',
      warehouseCity: '',
      phoneUser: '',
      itemsOriginEdit: [],
      isKomchatUser: this.$store.state.dashboard.profile.is_komchat === 1,
      isKomshipUser: this.$store.state.dashboard.profile.is_komship === 1,
      addressNameMaps: '',
      initialPlaces: {
        lat: '',
        lng: '',
      },
    }
  },
  methods: {
    async onSubmit() {
      if (!this.initialPlaces.lat || !this.initialPlaces.lng) {
        this.$toast_error({ message: 'Titik lokasi peta harus diisi' })
        return
      }
      try {
        this.isLoading = true
        await apiAddWareHouses({
          name: this.warehouseName, detail_address: this.warehouseAddress, destination_id: this.warehouseCity?.id, zip_code: this.warehouseCity?.zip_code, pic_name: this.picName, pic_phone: this.phoneUser.customerPhone || this.phoneUser, lat: this.initialPlaces.lat, long: this.initialPlaces.lng,
        })
        this.$emit('onAddWareHouse')
        this.$emit('refresh')
        this.$toast_success({ message: 'Gudang berhasil ditambahkan' })
        this.warehouseName = ''
        this.warehouseAddress = ''
        this.addressNameMaps = ''
        this.initialPlaces = { lat: '', lng: '' }
      } catch {
        this.$toast_error({ message: 'Gagal menambahkan gudang' })
      } finally {
        this.isLoading = false
      }
    },
    onCancel() {
      this.warehouseName = ''
      this.warehouseAddress = ''
      this.addressNameMaps = ''
      this.initialPlaces = { lat: '', lng: '' }
      this.$emit('onAddWareHouse')
    },
    setCustomerPhone(phone) {
      this.phoneUser = phone.customerPhone
    },
    onSearchOrigin(search, loading) {
      if (search.length) {
        this.searchOrigin(loading, search, this)
      }
    },
    searchOrigin: _.debounce((loading, search, that) => {
      loading(true)
      that.loadOrigin(search).then(() => loading(false))
    }, 500),
    loadOrigin(search) {
      return this.$http_komship
        .get(`/v1/destination?search=${search}`)
        .then(response => {
          this.itemsOriginEdit = response.data.data.data
        })
        .catch(err => {
          this.$toast_error({
            message: err.response?.data?.message || 'Gagal memuat data asal',
          })
        })
    },
    updateDataLocation(data) {
      this.addressNameMaps = data.address
      this.initialPlaces = {
        lat: data.lat,
        lng: data.lng,
      }
    },
  },
}
</script>
